import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

import checkoutValidation from "./components/checkout-validation";
import productPage from "./components/product-page";
import cookie from "./components/cookie";

Alpine.plugin(collapse);
window.Alpine = Alpine;

document.addEventListener("alpine:init", () => {
	Alpine.data("checkoutValidation", checkoutValidation);
	Alpine.data("productPage", productPage);
	window.Alpine.data("cookie", cookie);
});
Alpine.start();
